// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../img/background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Subwallet_subwallet__group__FXC21 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  width: 100%;
}
@media only screen and (max-width: 81.25em) {
  .Subwallet_subwallet__group__FXC21 {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media only screen and (max-width: 37.5em) {
  .Subwallet_subwallet__group__FXC21 {
    grid-template-columns: 100%;
  }
}

.Subwallet_balance__VDpSi {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 2rem;
  border-radius: 1rem;
  background-color: var(--color-primary-3);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  transition: all 0.4s;
}
.Subwallet_balance__amount__sK9l8 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
}
.Subwallet_balance__amount__sK9l8 > :first-child {
  display: flex;
  flex-direction: column;
}
.Subwallet_balance__btns__Z2nWb {
  display: flex;
  margin-bottom: 4rem;
}
.Subwallet_balance__btns__Z2nWb > :not(:last-child) {
  margin-right: 1rem;
}

.Subwallet_notPaid__f9\\+MA {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-error);
  color: var(--color-white);
  margin: 0.5rem 0;
  width: 100%;
  text-align: center;
}

.Subwallet_partPaid__R7Rp2 {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-yellow);
  color: var(--color-dark);
  margin: 0.5rem 0;
  width: 100%;
  text-align: center;
}

.Subwallet_paid__\\+qr4x {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-green);
  color: var(--color-white);
  margin: 0.5rem 0;
  width: 100%;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Subwallet/Subwallet.module.scss"],"names":[],"mappings":"AAGC;EACC,aAAA;EACA,qCAAA;EACA,SAAA;EACA,WAAA;AAFF;AAIE;EAND;IAOE,qCAAA;EADD;AACF;AAGE;EAVD;IAWE,2BAAA;EAAD;AACF;;AAKA;EACC,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,wCAAA;EACA,yDAAA;EACA,sBAAA;EACA,oBAAA;AAFD;AAIC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AAFF;AAIE;EACC,aAAA;EACA,sBAAA;AAFH;AAMC;EACC,aAAA;EACA,mBAAA;AAJF;AAME;EACC,kBAAA;AAJH;;AASA;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AAND;;AASA;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,qCAAA;EACA,wBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AAND;;AASA;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AAND","sourcesContent":["@import '../variables/breakpoints';\n\n.subwallet {\n\t&__group {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(3, 1fr);\n\t\tgap: 2rem;\n\t\twidth: 100%;\n\n\t\t@media only screen and (max-width: $bp-1300) {\n\t\t\tgrid-template-columns: repeat(2, 1fr);\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\tgrid-template-columns: 100%;\n\t\t}\n\t\t\n\t}\n}\n\n.balance {\n\tdisplay: flex;\n\tflex-direction: column;\n\tbox-sizing: border-box;\n\tpadding: 2rem;\n\tborder-radius: 1rem;\n\tbackground-color: var(--color-primary-3);\n\tbackground-image: url('../../img/background.png');\n\tbackground-size: cover;\n\ttransition: all 0.4s;\n\n\t&__amount {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tmargin-bottom: 1rem;\n\n\t\t& > :first-child {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t}\n\t}\n\n\t&__btns {\n\t\tdisplay: flex;\n\t\tmargin-bottom: 4rem;\n\n\t\t& > :not(:last-child) {\n\t\t\tmargin-right: 1rem;\n\t\t}\n\t}\n}\n\n.notPaid {\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\tline-height: 1;\n\tfont-size: 1rem;\n\tborder-radius: 1rem;\n\tbackground-color: var(--color-error);\n\tcolor: var(--color-white);\n\tmargin: 0.5rem 0;\n\twidth: 100%;\n\ttext-align: center;\n}\n\n.partPaid {\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\tline-height: 1;\n\tfont-size: 1rem;\n\tborder-radius: 1rem;\n\tbackground-color: var(--color-yellow);\n\tcolor: var(--color-dark);\n\tmargin: 0.5rem 0;\n\twidth: 100%;\n\ttext-align: center;\n}\n\n.paid {\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\tline-height: 1;\n\tfont-size: 1rem;\n\tborder-radius: 1rem;\n\tbackground-color: var(--color-green);\n\tcolor: var(--color-white);\n\tmargin: 0.5rem 0;\n\twidth: 100%;\n\ttext-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subwallet__group": `Subwallet_subwallet__group__FXC21`,
	"balance": `Subwallet_balance__VDpSi`,
	"balance__amount": `Subwallet_balance__amount__sK9l8`,
	"balance__btns": `Subwallet_balance__btns__Z2nWb`,
	"notPaid": `Subwallet_notPaid__f9+MA`,
	"partPaid": `Subwallet_partPaid__R7Rp2`,
	"paid": `Subwallet_paid__+qr4x`
};
export default ___CSS_LOADER_EXPORT___;
